import React from "react";
import "./SlotGamesSoftwareFeaturesStyle.scss";
import { slotGamesSoftwareFeaturesTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";

const SlotGamesSoftwareFeaturesSection = () => {
  return (
    <section className="slot-games-software-features-section">
      <div className="slot-games-software-features-wrap">
        <SectionHeading>
          {slotGamesSoftwareFeaturesTextContent.headingText}
        </SectionHeading>

        <div className="slot-games-software-features-box">
          <div className="card-grid">
            <div className="img-box">
              <img src={slotGamesSoftwareFeaturesTextContent.imageSrc} alt="Image" />
            </div>
            
            {slotGamesSoftwareFeaturesTextContent.content.map((section, index) => (
              <div className="card" key={index}>
                <div className="card-header">
                  <div className="icon-box">
                    <img src={section.iconSrc} alt="Image" />
                  </div>
                  <h5 className="title-text">{section.titleText}</h5>
                </div>

                <div className="card-body">
                  <p className="para-text">{section.paraText}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SlotGamesSoftwareFeaturesSection;
